export const Pages = Object.freeze({
  PLAID_INCOME_VERIFICATION: Symbol('PlaidIncomeVerification'),
  FUNDING_WRAPPER: Symbol('FundingWrapper'),
  INCOME_VERIFICATION: Symbol('IncomeVerification'),
  INCOME_VERIFICATION_PENDING: Symbol('IncomeVerificationPending'),
  SPOUSAL_RELATIONSHIP: Symbol('SpousalRelationship')
});

export const ApplicationStage = Object.freeze({
  EMAIL_AND_PASSWORD: 1,
  CONTACT_INFO: 3,
  SECURE_INFO: 4,
  BANK_VERIFICATION: 5,
  APPROVAL_PENDING: 6,
  DENIED: -7,
  PROFILE: 7,
  CURRENT_LOAN: 8,
  INCOME_VERIFICATION: 9,
  PROFILE_TWO: 10,
  APP_FINISH: 11
})

export const FundingStage = Object.freeze({
  DEBIT_CARD_ENTRY: 1,
  METHOD_SELECTION: 2,
  EFTA_SIGNING: 3
})

export const UserIdVerification = Object.freeze({
  VERIFIED: 1,
  VERIFICATION_REQUESTED: -1,
  FULL_VERIFICATION_REQUESTED: -2,
  VERIFICATION_PENDING: -5
})